<template>
  <div class="accordion-item">
    <h2 class="accordion-header" id="identify-accordion-header">
      <button 
        class="accordion-button" 
        :class="{ collapsed: !isActive }"
        type="button" 
        data-bs-toggle="collapse" 
        data-bs-target="#identify-accordion-body" 
        :aria-expanded="isActive"
        aria-controls="identify-accordion-body">
        1. {{ $t("Identifisering") }}
        <span 
          class="fa fa-check float-right text-success ms-2"
          :class="{ 'd-none': !wizardStore.isStepCompleted(1) }"
          style="line-height: 24px"></span>
      </button>
    </h2>
    <div id="identify-accordion-body"
      class="accordion-collapse collapse"
      :class="{ show: isActive }"
      data-bs-parent="#booking-accordions">
      <div class="accordion-body">
        <!-- Logged in state -->
        <div v-if="isLoggedIn" id="logged-in-state">
          <p class="alert alert-success">
            {{ $t("Du er logget inn med Vipps som {fullName}", { fullName: vippsUser.firstName + ' ' + vippsUser.lastName }) }}.
          </p>
        </div>
        
        <!-- Logged out state -->
        <div v-else id="logged-out-state">
          <div id="vipps-login-button">
            <a :href="`/r/${hash}/redirect`" class="btn btn-vipps">
              {{ $t('Logg inn med Vipps') }}
            </a>
          </div>
        </div>

        <!-- Feedback -->
        <div v-if="feedback" class="feedback mt-2" v-html="feedback"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import wizardStore from '../../state/vippsWizardStore.js'

const props = defineProps({
  isActive: Boolean
})

// Computed properties
const vippsUser = computed(() => wizardStore.state.vippsUser.value)
const feedback = computed(() => wizardStore.state.feedback.value)
const hash = computed(() => wizardStore.state.hash.value)

const isLoggedIn = computed(() => {
  return vippsUser.value.mobile && vippsUser.value.firstName
})
</script>
